import { defineComponent as _defineComponent } from 'vue'
import BCXDottedBox from '@/components/molecules/BCXDottedBox.vue';
import { PropType } from 'vue';
import X from '@/components/svg-components/X.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDottedCollapsible',
  props: {
  isOpened: { type: Boolean },
  addTopPadding: { type: String, default: '0' },
  addBottomPadding: { type: String, default: '0' },
  showCloseButton: {
    type: Boolean,
    default: true,
  },
  background: {
    type: String as PropType<'none' | 'white'>,
    default: 'none'
  }
},
  emits: ["after-close", "update:is-opened"],
  setup(__props) {





return { __sfc: true,BCXDottedBox, X }
}

})